import { APP_DEV_EXPERIMENTAL } from 'App/featuresFlags';
import { useGetTags } from 'domains/Auth/hooks';

function useHasExperimentalAppTag(): boolean {
  const tags = useGetTags();
  return tags.includes(APP_DEV_EXPERIMENTAL);
}

export default useHasExperimentalAppTag;
